import { useDispatch } from "react-redux";
import { actionCreators } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";

export const useMessageStepDefinition = (onSubmit: () => void) => {
  const dispatch = useDispatch();
  const { setMessage } = bindActionCreators(actionCreators, dispatch);

  const handleSubmit = (message: string) => {
    setMessage(message);
    onSubmit();
  };

  return {
    onSubmit: handleSubmit,
  };
};
